var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.notification.active)?_c('div',{staticClass:"container bg-br-green-light text-center p-5 mb-10"},[_c('h3',{staticClass:"fluid-base leading-tight mb-5"},[_vm._v(_vm._s(_vm.notification.heading))]),_vm._v(" "),_c('div',{staticClass:"text-copy",domProps:{"innerHTML":_vm._s(_vm.notification.description)}}),_vm._v(" "),_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }